import Api from "lib/api/httpRequestHelper";

import {
  mapColetasHistoricoPageFromApi,
  unwrapApiResult,
} from "../../monitoramento-preco/components/mpMappers";
import buildColetasQueryParams from "./buildColetasQueryParams";
import {
  COLETAS_EXPORT_MAX,
  COLETAS_EXPORT_PAGE_SIZE,
} from "./coletas-export-constants";

async function fetchColetasPage(filterState, page, pageSize) {
  const query = buildColetasQueryParams(filterState, { page, pageSize });
  const res = await Api.get("coletas", "priceMonitoring", query, true);
  return mapColetasHistoricoPageFromApi(unwrapApiResult(res));
}

export default async function fetchAllColetas(
  filterState,
  { onProgress } = {},
) {
  const allItems = [];
  let totalCount = 0;
  let page = 1;

  while (allItems.length < COLETAS_EXPORT_MAX) {
    onProgress?.({
      loaded: allItems.length,
      total: totalCount || null,
    });

    const mapped = await fetchColetasPage(
      filterState,
      page,
      COLETAS_EXPORT_PAGE_SIZE,
    );
    totalCount = mapped.totalCount;

    if (!mapped.items.length) break;

    allItems.push(...mapped.items);

    if (allItems.length >= totalCount) break;
    if (allItems.length >= COLETAS_EXPORT_MAX) break;
    if (page >= mapped.totalPages) break;

    page += 1;
    if (page > 200) break;
  }

  return {
    items: allItems.slice(0, COLETAS_EXPORT_MAX),
    totalCount,
    truncated: totalCount > COLETAS_EXPORT_MAX,
  };
}
